import { getNumberedEnv, isHostNumberedEnv } from "@utils/url-utils";
export const appVersion = "1.0.0-feature-ST-5421-prevent-bulk-workspace-role-upgrade-without-seat-new.0";
export const appTimestamp = "2026-11-05T11:09:26.000Z";
export const commitId = "caf187eedac433444e79d83a22672b4d0191d4ae";
export const commitUrl = "https://dev.azure.com/faro-connect/Stellar/_git/Dashboard/commit/caf187eedac433444e79d83a22672b4d0191d4ae?refName=refs%2Fheads%2Fmaster";
export const pullRequestId = "44771";
export const pullRequestUrl = "https://dev.azure.com/faro-connect/Stellar/_git/Dashboard/pullrequest/44771";
export const jiraTicketId = "ST-5421";
export const jiraTicketUrl = "https://faro01.atlassian.net/browse/ST-5421";
export const sentryDSNKey = "https://c9b011b3368bc41e188fcbae7fb7a872@o381590.ingest.sentry.io/4505674738499584";
export const localizeKey = "iKNI0OJMw3RLe";
export const muiProKey = "e750d7a2a7585a17ac2eaa4bc8a53c4aTz0xMTgwNzYsRT0xNzg3NjE1OTk5MDAwLFM9cHJvLExNPWFubnVhbCxQVj1RMS0yMDI2LFE9MTAsQVQ9bXVsdGksS1Y9Mg==";

/** Amplitude key for dev, staging and internal users in production (XG Platform - Internals & Testing) */
export const amplitudeKeyInternal = "c28b8a12d2b5f33ea25ddc3eb53dd116";

/** Amplitude key for non-internal users in production (XG Platform - Externals Prod) */
export const amplitudeKeyProd = "94dd222e61ffd229f51d8f5d4c7b2b62";

/**
 * Amplitude key for dev, staging and internal users in production (Sphere Dashboard (Stg))
 * This is the older Amplitude project that is being replaced with the XG Platform Amplitude project.
 * However, we still track in both projects until we are sure everything is working well in the new one.
 */
export const amplitudeKeyOldInternal = "6669713f5f821a32accec4f56cde20d9";

/**
 * Amplitude key for internal users in production (Sphere Dashboard (Prod))
 * This is the older Amplitude project that is being replaced with the XG Platform Amplitude project.
 * However, we still track in both projects until we are sure everything is working well in the new one.
 */
export const amplitudeKeyOldProd = "0f55bafc3d3b678c50ca73a88964be8a";
export const procoreApiUrlStaging = "https://sandbox.procore.com/rest/v1.0";
export const procoreApiUrlProduction = "https://api.procore.com/rest/v1.0";
export const autodeskApiUrl = "https://developer.api.autodesk.com/project/v1";
export const isNumberedEnv = isHostNumberedEnv(globalThis.location.host);
export const numberedEnv = isNumberedEnv ? getNumberedEnv(globalThis.location.host) : null;

/** ArcGIS API key named "xg-dashboard-development" with basemap and geocoding services (expires April 1st 2027) */
export const arcgisApiKeyDev = "AAPTar4R63_xHaey7EsotTDF1aQ..MM9B0_JcMIw0uP3hPEwvOW_CvBvjJlyO_IWL8KUr7RGx3dUwG0qdNyWkxkQ9EbZ8xPfldefVBIGMoCP0g54oxdmeRb0SmFWBTG3yjI6KApLpPMtZb9HpRVn7SOQh3Og3P5WFfon9c4n2vD27pS9lNRIPbmJDABvXQ5mLOGW6126Rzbn5f9xLfqCdSfUPL7VyFPlfgbB02BwgvKgVc00cZ6Qww2cpaGUlEwsRX-KdalOiLRRUMLfdcnG2x7Cvy7W2HwLZcLmmtbKHAT1_mxgNz3OZ";

/** ArcGIS API key named "xg-dashboard-production" with basemap and geocoding services (expires April 1st 2027) */
export const arcgisApiKeyProd = "AAPTaAoxK46CPzu2tsZDan5-sXQ..j7K_hqlDGiqKsvQ8GLKObPVjNZEDbe-Rb7ewnk38RjV0A2-1BBbUPqh8XBtyE0uJBwIbLSvDYAyfxi4rqgkQ6gV2v67P7vtMX__9UHs90pN_-rnJ3b8qwXvPnD3lGIAmeM1T-NMZ31OFrbm6dOXEpoqgMcdFEcyCe6qfsnKgQsAwPerGJtjE_cN0BVd_h77faLy4Bi0pS6yp1DIXPrEsuy-WmhMbJFaVbS5u4fF1kxXrpyX2qX8MqL9PNub_GVXYn2LXmllye6tEAT1_2XoHxgne";

/** Intercom App Id to use in the development environments (both dev and staging) */
export const intercomAppIdDev = "ufxujusd";

/** Intercom App Id to use in the production environments */
export const intercomAppIdProd = "cuydqq3r";